module.exports = __webpack_public_path__ + "media/images/icon__plus@2x-cc534c5104bb39d58f1adc265f68441e.png";